import { type Offer } from '@cx-modules/offers-delivery-api-service';
import { getValueFromPlaceholder } from '@cx-modules/offers-placeholder-translations';

import { type OfferCardProps } from '../componets/OfferCard/OfferCard';

import { isAutohide, type OffersSlimVariant } from './variants';

export type OfferProps = Omit<OfferCardProps, 'onClick'> &
  Pick<Offer, 'id'> & {
    bookie: string;
    url?: string;
    variant: OffersSlimVariant;
  };

type contractToPropsOptions = {
  placeholders?: string;
  translation?: any;
  variant?: OffersSlimVariant;
};

type modifiedOffer = Offer & { offerCtaTemplate: string };

type contractToProps = (offer: modifiedOffer, options: contractToPropsOptions) => OfferProps;

const offersToProps: contractToProps = (
  {
    bookmaker,
    bookmakerCode,
    clickOutUrl,
    clickoutUrl,
    displayTitle,
    displayTitleTemplate,
    featuredLabels,
    fullTerms,
    id,
    offerCta,
    offerCtaTemplate,
    shortTerms,
  },
  { placeholders, translation, variant },
) => {
  const url = clickOutUrl || clickoutUrl?.url;

  const ctaText = getValueFromPlaceholder({
    placeholders,
    template: offerCtaTemplate,
    translatorFunction: translation,
    value: offerCta,
  });
  const heading = getValueFromPlaceholder({
    placeholders,
    template: displayTitleTemplate,
    translatorFunction: translation,
    value: displayTitle,
  });
  const disabled = (isAutohide({ variant }) && !ctaText) || !url;

  return {
    bookie: bookmakerCode,
    color: bookmaker.primaryColor,
    ctaText,
    disabled,
    heading,
    id,
    label: featuredLabels instanceof Array ? featuredLabels[0] : featuredLabels || undefined,
    logoAlt: bookmaker.name || bookmakerCode,
    logoUrl: bookmaker.logoFull?.url,
    text: variant === 'autohide' ? fullTerms : shortTerms ? `<p>${shortTerms}</p>` : undefined,
    url,
    variant: variant ?? 'default',
  };
};

export default (offers: Offer[] | null, opts: contractToPropsOptions) =>
  (offers || []).map(item => offersToProps(item as modifiedOffer, opts));
